'use client';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { useTranslations } from 'next-intl';
import Header from '@/shared/Header';

export default function SomethingWentWrong() {
  const t = useTranslations('error');
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Header />
      <div className=""></div>
      <main className="flex min-h-full w-full flex-1 flex-col items-center gap-y-[30px] bg-[#FBF2EC] py-[120px]">
        <Image src="/error.png" width={300} height={300} alt="not found" />
        <h1 className="text-h1 font-black text-title">{t('title')}</h1>
        <p className="max-w-[500px] text-center text-lg text-paragraph">
          {t('text')}
        </p>
        <Link
          href="/"
          className="w-fit rounded-[30px] bg-primary px-[30px] py-[10px] text-white ring-2 ring-primary hover:bg-white hover:text-title"
        >
          {t('button')}
        </Link>
      </main>
    </div>
  );
}
